import { styled } from 'styled-components';

export const MainDiv = styled.div`
  overflow-x: hidden;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  gap: 100px;
  height: 100%;
`;
